import { HttpErrorResponse } from '@angular/common/http';

import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<{}>()('sample-data', {
  customActions: adapter => ({
    createSampleData: state => adapter.markAsPending(state),
    createSampleDataSuccess: state => adapter.markAsLoaded(state),
    createSampleDataFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),

    deleteSampleData: state => adapter.markAsPending(state),
    deleteSampleDataSuccess: state => adapter.markAsLoaded(state),
    deleteSampleDataFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
  }),
});

export {
  actions as SampleDataActions,
  selectors as SampleDataSelectors,
  reducer as SampleDataReducer,
  namespace as SampleDataNamespace,
};
